module.exports = __webpack_public_path__ + "h5/img/cs_09.72107ced.jpg";